import { Controller } from 'stimulus';
export default class extends Controller {
  static targets = ['handle'];

  static values = {
    isMouseDown: Boolean,
    isTouch: Boolean,
    InitialMousePosition: Object,
    InitialElementTranslate: Object,
  };

  touchmove(event) {
    const newTranslateX =
      this.startingElementTranslateValue.x +
      event.targetTouches[0].screenX -
      this.mouseDownCoordinates.x;
    const newTranslateY =
      this.startingElementTranslateValue.y +
      event.targetTouches[0].screenY -
      this.mouseDownCoordinates.y;

    this.element.style.translate = `${newTranslateX}px ${newTranslateY}px`;
  }

  drag(event) {
    if (!this.isMouseDownValue || this.isTouch) {
      return;
    }

    const newTranslateX =
      this.startingElementTranslateValue.x + event.clientX - this.mouseDownCoordinates.x;
    const newTranslateY =
      this.startingElementTranslateValue.y + event.clientY - this.mouseDownCoordinates.y;
    const isOverHandle = (x, y) => document.elementFromPoint(x, y) === this.handleTarget;
    const dragMargin = 30; // distance at which dragged popver stops before the element of higher z-index

    if (
      isOverHandle(event.clientX + dragMargin, event.clientY) &&
      isOverHandle(event.clientX - dragMargin, event.clientY) &&
      isOverHandle(event.clientX, event.clientY - dragMargin) &&
      isOverHandle(event.clientX, event.clientY + dragMargin)
    ) {
      this.element.style.translate = `${newTranslateX}px ${newTranslateY}px`;
    }
  }

  mouseDown(event) {
    this.isTouch = event.type === 'touchstart';
    this.startingElementTranslateValue = {
      x: parseInt(window.getComputedStyle(this.element).translate.split(' ')[0]),
      y: parseInt(window.getComputedStyle(this.element).translate.split(' ')[1]),
    };

    if (event.targetTouches) {
      this.mouseDownCoordinates = {
        x: event.targetTouches[0].screenX,
        y: event.targetTouches[0].screenY,
      };
    } else {
      this.mouseDownCoordinates = { x: event.clientX, y: event.clientY };
    }
    this.isMouseDownValue = true;
  }

  mouseUp() {
    this.#isMouseDown = false;
  }

  get #isMouseDown() {
    return this.isMouseDownValue;
  }

  set #isMouseDown(val) {
    this.isMouseDownValue = val;
  }
}
